export const getCount = (count) => {
  let start = count?.indexOf('(');
  let end = count?.indexOf(')');
  return parseInt(count?.slice(start + 1, end));
};
export const getTotalItemsCount = (searchQueryResult) => {
  let count = 0;
  searchQueryResult?.map((searchResult) => {
    if (searchResult.count) {
      count += getCount(searchResult.count);
    }
  });
  return count;
};

export const checkFilterExists = (data, filter) => {
  let searchResult = data.data;
  for (let index = 0; index < searchResult.length; index++) {
    if (searchResult[index]?.key === filter) {
      return true;
    }
  }
  return false;
};

export const onScroll = (e, callBack, data, boolean) => {
  if (boolean && data.length === 1) {
    const diff =
      window.innerHeight + document.documentElement.scrollTop >=
      Math.floor(document.documentElement.offsetHeight * 0.75);
    if (diff) {
      callBack(data);
    }
  }
};
export const detectScrollEnd = (e, updateContent) => {
  var bottom =
    Math.floor(
      Math.abs(
        e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight,
      ),
    ) == 0;
  if (bottom) {
    updateContent();
  }
};

export const useDebounce = (func, milliseconds) => {
  const time = milliseconds || 400;
  let timer;

  return (event) => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(func, time, event);
  };
};

export const getSectionTitle = (title) => {
  switch (title) {
    case 'Questions':
      return 'Q/A';
    default:
      return title;
  }
};

export const updateRecentSearches = (search) => {
  let recentSearches = localStorage.getItem('recentSearch')
    ? JSON.parse(localStorage.getItem('recentSearch'))?.split(',')
    : [];
  recentSearches = [search, ...recentSearches];
  let uniqueRecentSearch = new Set();
  for (let i = 0; i < recentSearches.length; i++)
    uniqueRecentSearch.add(recentSearches[i]);
  uniqueRecentSearch = Array.from(uniqueRecentSearch);
  if (uniqueRecentSearch.length > 0) {
    localStorage.setItem(
      'recentSearch',
      JSON.stringify(uniqueRecentSearch.join(',')),
      '/',
    );
  }
};

export const diaperVariations = [
  'Baby Diaper Pants',
  'Diaper Pants',
  'Diaper Pnts',
  'Diaper Pans',
  'Diapr Pants',
  'Diapers',
  'Diaprs',
  'Dipers',
  'Diapoers',
  'Baby Diaper Pnts',
  'Baby Diaper Pans',
  'Baby Diapr Pants',
  'Newborn Diapers',
  'Newborn Diaprs',
  'Newborn Dipers',
  'Newborn Diapoers',
  'Disposable Diapers',
  'Disposabl Diapers',
  'Disposble Diapers',
  'Disposabl Diaprs',
];
export const carrierVariations = [
  'Carrier',
  'Baby Carrier',
  'mylo baby carrier',
  'carier',
];

const sortArrayByReference = (arrayToSort, referenceArray) => {
  const referenceMap = new Map();
  referenceArray.forEach((value, index) => {
    referenceMap.set(value, index);
  });

  return arrayToSort?.sort((obj1, obj2) => {
    const index1 = referenceMap.has(obj1?.id)
      ? referenceMap.get(obj1?.id)
      : Infinity;
    const index2 = referenceMap.has(obj2.id)
      ? referenceMap.get(obj2.id)
      : Infinity;

    return index1 - index2;
  });
};

export const changeProductSorting = (searchData, searchString) => {
  const productSearchdata = searchData?.[0]?.data || searchData;
  let diaperStringExist = null;
  let carrierStringExist = null;
  for (let i = 0; i < diaperVariations?.length - 1; i++) {
    diaperStringExist = diaperVariations[i]
      .toLowerCase()
      .includes(searchString?.toLowerCase());

    if (diaperStringExist) break;
  }

  for (let i = 0; i < carrierVariations?.length - 1; i++) {
    carrierStringExist = carrierVariations[i]
      .toLowerCase()
      .includes(searchString?.toLowerCase());

    if (carrierStringExist) break;
  }

  if (diaperStringExist) {
    const sortingList = [
      '2378',
      '2379',
      '2380',
      '2381',
      '3483',
      '3484',
      '3485',
      '3486',
      '3930',
      '3932',
      '3909',
      '3917',
      '3931',
      '3920',
    ];

    sortArrayByReference(productSearchdata, sortingList);
  } else if (carrierStringExist) {
    const sortingList = ['3434', '3433'];
    sortArrayByReference(productSearchdata, sortingList);
  }
};
